import { useQuery } from '@tanstack/react-query';

import UsersService from '~/services/UsersService';

import { usersQueryKeys } from './usersQueryKeys';

export type EmployeeUserOption = {
  full_name: string;
  id_account: string;
  email: string;
};

export function useGetEmployeeUsers(filter?: string, enabled = true) {
  return useQuery<Array<EmployeeUserOption>>({
    queryKey: usersQueryKeys.employeeUsers(filter),
    enabled,
    queryFn: async ({ signal }) => {
      return await UsersService.getEmployeeUsers(filter, 50, 0, undefined, { signal });
    },
  });
}
